import { Chip } from '@mui/material';

import { brlDecimal } from 'util/format';

type PedidoDescontoChip = {
    peOferta: number;
    size?: 'small' | 'medium';
};

export function PedidoDescontoChip({ peOferta, size = 'medium' }: PedidoDescontoChip) {
    return (
        <Chip
            size={size}
            label={`${brlDecimal(peOferta)}% OFF`}
            color={peOferta >= 70 ? 'error' : 'warning'}
            sx={{
                height: size === 'small' ? 20 : 24,
                fontSize: size === 'small' ? 13 : 14,
                fontWeight: 500,
            }}
        />
    );
}
